export default "__VITE_ASSET__kn6JP78y__"